import { createSlice } from "@reduxjs/toolkit";

const getUserFromStorage = () => {
  const userStr = localStorage.getItem("user");
  try {
    return userStr ? JSON.parse(userStr) : null;
  } catch {
    return null;
  }
};

const initialState = {
  user: getUserFromStorage(),
  isAuthenticated: !!localStorage.getItem("token"),
  loading: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, action) => {
      // Ensure USN is properly captured from the payload
      const userData = {
        id: action.payload.id || action.payload._id,
        name: action.payload.name,
        email: action.payload.email,
        usn: action.payload.usn || action.payload.USN, // Add USN here
        branch: action.payload.branch,
        semester: action.payload.semester,
        role: action.payload.role,
        profilePicture: action.payload.profilePicture,
        token: action.payload.token,
      };
      state.user = userData;
      state.isAuthenticated = true;
      localStorage.setItem("user", JSON.stringify(userData));
      if (action.payload.token) {
        localStorage.setItem("token", action.payload.token);
      }
    },
    updateUser: (state, action) => {
      state.user = { ...state.user, ...action.payload };
      localStorage.setItem("user", JSON.stringify(state.user));
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
    },
  },
});

export const { setUser, updateUser, setLoading, setError, logout } =
  authSlice.actions;
export default authSlice.reducer;
